<template lang="pug">

  v-container.pageGroupContainer(tag="section" fluid)

    //-
      -
      -
      VOLTAR + PLANO
      -
      -
      -

    v-row

      v-col(cols="12" sm="6").column

        sos-button(@buttonClick="goBackToGroupScales" size="medium" color="default" buttonLabel="Voltar para o grupo" buttonIcon="mdi-arrow-left" buttonIconSize="16").mr-auto.btnVoltar

    .pageBody

      //-
        -
        -
        CABEÇALHO (IMAGEM DO GRUPO, INFORMAÇÕES DO GRUPO E BOTÕES [CONVIDAR E ETC])
        -
        -
        -

      .groupUserDutiesPageHeader

        //- template(v-if="group")

        .csCol.csCol--1

          .groupTitleArea

            .groupTitleImage

              .groupImage

                .groupUserImage(:style="{ backgroundImage: 'url(' + userLocalProfile.userImage + ')' }" v-if="userLocalProfile && userLocalProfile.userImage")
                .groupUserImage(v-else)

            .groupTitleText

              h2.blockTitle(v-if="loadingUserProfile === false") {{ userLocalProfile.userName.length === 0 ? 'Não informado' : userLocalProfile.userName }}
              h2.blockTitle(v-else)
                | Carregando...

              //- .userProfile.mt-3
                .userProfileItem
                  b
                    | CRM:&nbsp;
                  span(v-if="loadingUserProfile === false")
                    | {{ userLocalProfile.userCrm.length === 0 ? 'Não informado' : userLocalProfile.userCrm }}
                  span(v-else)
                    | Carregando...
                .userProfileItem
                  b
                    | CPF:&nbsp;
                  span(v-if="loadingUserProfile === false")
                    | {{ userLocalProfile.userCpf.length === 0 ? 'Não informado' : userLocalProfile.userCpf }}
                  span(v-else)
                    | Carregando...
                .userProfileItem
                  b
                    | Telefone:&nbsp;
                  span(v-if="loadingUserProfile === false")
                    | {{ userLocalProfile.userPhone.length === 0 ? 'Não informado' : userLocalProfile.userPhone }}
                  span(v-else)
                    | Carregando...
                .userProfileItem
                  b
                    | Dados bancários:&nbsp;
                  span(v-if="loadingUserProfile === false")
                    | {{ userLocalProfile.userPaymentProfile.length === 0 ? 'Não informado' : userLocalProfile.userPaymentProfile }}
                  span(v-else)
                    | Carregando...

        .csCol.csCol--2

          .groupTitleArea
            .groupTitleImage
              .groupImage
                .groupUserImage(:style="{ backgroundImage: 'url(' + (group && group.img ? group.img : groupplaceholder) + ')' }")

            .groupTitleText

              h2.blockTitle {{ group && group.nome ? group.nome : 'Carregando...' }}

              .userProfile.mt-5

                .sosField
                  sos-select(label="Especialidade" :items="selectScales" @sosSelectChanged="onSelectScale" :default="scaleID" :disabled="loadingDuties")

                .sosFieldGroup
                  .sosField.sosFieldColumn--1
                    sos-select(label="Mês" :items="selectMonths" @sosSelectChanged="selectedMonth" :default="currentMonth" :disabled="loadingDuties")
                  .sosField.sosFieldColumn--2
                    sos-select(label="Ano" :items="selectYears" @sosSelectChanged="selectedYear" :default="currentYear" :disabled="loadingDuties")

      //-
        -
        -
        PRÓXIMOS PLANTÕES
        -
        -
        -

      .groupUserDutiesHeader

        .loadingScale
          | Agendamentos
          //- | Próximos plantões

      .groupUserDuties(:class="{ 'groupUserDuties--loading': appointmentsDates.length > 0 && loadingDuties === true }")

        //- .groupUserDuties--loadingWrapper
          span Atualizando...

        //- .groupUserDutiesColumn--1

        //- .groupUserDutiesColumn--2

        .groupUserDutiesMonthWrapper

          //- .groupUserDutiesMonth--name
            | Agosto de 2022

          .groupUserDutiesMonth--duties(v-if="appointmentsDates.length > 0")

            div(v-for="date in appointmentsDates")
              .monthDay {{ date.title }}
              .monthDayBody
                table(border="0" cellspacing="0")
                  tr(style="background-color: aliceblue; color: #483d8b; font-weight: 600")
                    td Início
                    td(width="100") Duração
                    td(width="450") Paciente
                    td Especialidade
                    td Ações
                  tr(v-for="appointment in date.appointments")
                    td {{ appointment.startDate + ' às ' + appointment.startTime }}
                    td(width="100") {{ appointment.duration }}
                    td(width="450") {{ appointment.patientName }}
                    td {{ appointment.specialtyName }}
                    td
                      sos-button(@buttonClick="openAppointmentEditModal(appointment)" buttonLabel="Ver consulta" size="small" buttonIcon="" buttonIconSize="20" color="success")

            //-
              -
              - "CARTÃO" DO PLANTÃO
              -
              -

            //- .groupUserDutiesMonth--duty(v-for="duty in appointmentsDates" @click.stop.prevent="openAppointmentEditModal(duty.duty)" :class="{ 'groupUserDutiesMonth--duty__finished': !!duty.duty.start_location === true && !!duty.duty.end_location === true, 'groupUserDutiesMonth--duty__started': !!duty.duty.start_location === true && !!duty.duty.end_location === false, 'groupUserDutiesMonth--duty__cancelled': duty.duty.status === 'cancelado' }")

            //- .groupUserDutiesMonth--duty(v-for="duty in appointmentsDates" @click.stop.prevent="openAppointmentEditModal(duty.duty)")

              //- .dutyCard--passing(v-if="duty.isPassing")
                | PASSANDO

              .groupUserDutiesMonth--dutyBody

                //- .dutyLabel(v-if="!!duty.duty.start_location === true && !!duty.duty.end_location === true")
                  | ENCERRADO
                .groupUserDutiesMonth--dutyInner1
                  .groupUserDutiesMonth--dutyWeekDay {{ duty.dutyWeekDayName }}
                  .groupUserDutiesMonth--dutyDay {{ duty.dutyDay }}
                .groupUserDutiesMonth--dutyInner2
                  .groupUserDutiesMonth--dutyTime
                    span Início:
                    span {{ duty.dutyTime }}
                  .groupUserDutiesMonth--dutyTime
                    span Duração:
                    span {{ duty.dutyDuration }}
              //- .groupUserDutiesMonth--dutyValue
                | {{ duty.dutyValue }}
              .groupUserDutiesMonth--dutyValue
                | {{ duty.specialtyName }}
              .groupUserDutiesMonth--dutyValue(v-if="duty.patientName")
                | {{ duty.patientName }}

          .groupUserDutiesMonth--duties(v-else-if="appointmentsDates.length === 0 && loadingDuties === true")

            .loadingScale
              | Carregando agendamentos...

          .groupUserDutiesMonth--duties(v-else)

            .loadingScale(v-if="listeners.loadingGroupScales === 'no' && haveScales === false")
              | O grupo ainda não tem especialidades
            .loadingScale(v-else-if="scaleID === 'all'" v-html="`O município não tem agendamentos em <span style=\"color: #228b22; font-weight: 500\">${currentMonthName} de ${currentYear}</span>`")
            .loadingScale(v-else v-html="`O município não tem agendamentos em <span style=\"color: #228b22; font-weight: 500\">${currentMonthName} de ${currentYear}</span> na especialidade <span style=\"color: #228b22; font-weight: 500\">${scaleName}</span>`")

    detalhes-da-consulta(ref="appointmentEditModal" v-if="groupUsers")

</template>

<script>

  // Vuex
  import { mapState } from 'vuex'

  import userProfileBroken from '@/assets/images/user-profile-broken.png'
  import groupplaceholder from '@/assets/images/groupplaceholder.png'

  import { apiGetSpecialtyAppointmentsRef, apiGetMunicipalityAppointmentsBetweenTwoDatesRef } from '@/services/consultations'
  import { apiRefOpen, apiRefClose, getUserByUserID, getPatientByID } from '@/services/firebase'
  // import { rgxFirebaseKey, apiRefOpen, apiRefClose, getUserByUserID } from '@/services/firebase'

  //
  //

  import SosSelect from '@/components/SosSelect'
  import SosButton from '@/components/SosButton'

  import DetalhesDaConsulta from '@/modals/DetalhesDaConsulta'

  //
  // moment

  import moment from 'moment'
  import 'moment/locale/pt-br'
  // moment.locale('pt-BR')

  //
  //

  export default {
    name: 'GroupUserDuties',

    components: {
      'detalhes-da-consulta': DetalhesDaConsulta,

      'sos-select': SosSelect,
      'sos-button': SosButton,
    },

    /* mixins: [
    ], */

    data () {
      return {
        groupplaceholder,

        loadingDuties: true,

        dutiesRef: null,
        appointmentsDates: [],

        userID: '',
        groupID: '',

        scaleID: 'all',
        scaleName: 'Todas as especialidades',

        currentYear: '',
        currentMonth: '',
        currentMonthName: '',

        selectMonths: [
          { key: 'month_01', text: 'Janeiro', value: '01' },
          { key: 'month_02', text: 'Fevereiro', value: '02' },
          { key: 'month_03', text: 'Março', value: '03' },
          { key: 'month_04', text: 'Abril', value: '04' },
          { key: 'month_05', text: 'Maio', value: '05' },
          { key: 'month_06', text: 'Junho', value: '06' },
          { key: 'month_07', text: 'Julho', value: '07' },
          { key: 'month_08', text: 'Agosto', value: '08' },
          { key: 'month_09', text: 'Setembro', value: '09' },
          { key: 'month_10', text: 'Outubro', value: '10' },
          { key: 'month_11', text: 'Novembro', value: '11' },
          { key: 'month_12', text: 'Dezembro', value: '12' },
        ],

        userLocalProfile: {
          userID: null,
          isMe: null,
          userImage: null,
          userImageIsValid: null,
          userName: null,
          userEmail: null,
          userPhone: null,
          userCpf: null,
          userCrm: null,
          userPaymentProfile: null,
        },

        loadingUserProfile: true,

        groupPatients: [],
      }
    },

    computed: {
      ...mapState(['userSession', 'group', /* 'plans', */ 'listeners', 'groupUsers']),

      selectYears () {
        const getCurrentYear = moment().get('year')

        const previousYear = String(getCurrentYear - 1)
        const currentYear = String(getCurrentYear)
        const nextYear = String(getCurrentYear + 1)

        return [
          {
            key: `year_${previousYear}`,
            value: previousYear,
            text: previousYear,
          },
          {
            key: `year_${currentYear}`,
            value: currentYear,
            text: currentYear,
          },
          {
            key: `year_${nextYear}`,
            value: nextYear,
            text: nextYear,
          },
        ]
      },

      haveScales () {
        if (!!this.listeners.groupScales === false || (!!this.listeners.groupScales === true && !Array.isArray(this.listeners.groupScales))) {
          return false
        }

        return this.listeners.groupScales.length > 0
      },

      selectScales () {
        if (!!this.listeners.groupScales === false || (!!this.listeners.groupScales === true && !Array.isArray(this.listeners.groupScales))) {
          return []
        }

        // console.log('::: PLANTÕES DO USUÁRIO -> SCALES LIST:', this.listeners.groupScales)

        return this.listeners.groupScales.length > 0 ? [
          {
            key: 'all',
            value: 'all',
            formattedText: '<div class="userShiftsScaleItem"><i aria-hidden="true" class="mdi mdi-calendar-multiple userShiftsScaleItemIcon"></i><span class="userShiftsScaleItemText">&nbsp;&nbsp;Todas as especialidades</span></div>',
            text: 'Todas as especialidades',
          },
          ...this.listeners.groupScales.map(scale => ({
            key: 'scale_' + scale.scaleID,
            value: scale.scaleID,
            text: scale.scaleName,
          })),
        ] : []
      },
    },

    watch: {
      selectScales: {
        immediate: true,
        handler (defaultNew, defaultOld)
        {
          const oldOptions = typeof defaultOld === 'object' && Array.isArray(defaultOld) ? defaultOld : []
          const newOptions = typeof defaultNew === 'object' && Array.isArray(defaultNew) ? defaultNew : []

          // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> [selectScales] UPDATED:', oldOptions, newOptions)

          //
          // PRÉ-SELECIONA A PRIMEIRA ESCALA, DEPOIS QUE O AS ESCALAS DO GRUPO FORAM COLOCADAS NO VUEX
          //

          if (oldOptions.length === 0)
          {
            if (newOptions.length > 0 && this.dutiesRef === null)
            {
              //
              //
              //
              // SENHOR JESUS
              //
              // testar
              //
              //
              //

              // const scaleID = this.$store.state.listeners.groupScales[0].scaleID
              // const scaleName = this.$store.state.listeners.groupScales[0].scaleName

              const scaleID = newOptions[0].value
              const scaleName = newOptions[0].value === 'all' ? 'Todas as especialidades' : newOptions[0].text

              this.scaleID = scaleID
              this.scaleName = scaleName

              // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> [selectScales] SYSTEM SELECTED "' + scaleName + '" SCALE. (ID: ' + scaleID + ')')

              // this.startDuties(scaleID, scaleName)
            }
            else if (this.listeners.loadingGroupScales === 'no' && this.haveScales === false)
            {
              this.loadingDuties = false

              // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> [selectScales] SYSTEM CAN\'T SELECT SCALE: This group doesn\'t have any scale.')
            }
          }
        },
      },
    },

    /* created () {
      // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> created')
      // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> created [VUEX]:', this.listeners.groupScales)
    }, */

    mounted () {
      // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> mounted [VUEX]:', this.listeners.groupScales)

      const { groupID, userID } = this.$route.params

      this.userID = userID
      this.groupID = groupID

      //
      // moment init
      moment.locale('pt-BR')

      //
      // aplica mês e ano vigentes
      this.setCurrentYearMonth()

      //
      // carrega dados do grupo caso o usuário não tenha passado pela tela de GRUPO
      // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> [mounted] LOADING GROUP "' + groupID + '"...')
      this.$store.dispatch('loadGroupPage', groupID)

      //
      // load user
      // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> [mounted] LOADING USER "' + userID + '"...')
      this.loadUser(userID)

      //
      // DEBUG
      // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> mounted:', groupID, userID, this.$store.state.group)
    },

    // https://stackoverflow.com/questions/10246215/how-to-destroy-a-javascript-object
    // https://www.digitalocean.com/community/tutorials/vuejs-component-lifecycle-pt

    updated () {
      /* CARREGA PLANTÕES DA ESCALA */

      if (
        this.dutiesRef === null &&
        this.currentYear !== '' &&
        this.currentMonth !== '' &&
        this.scaleID !== '' &&
        this.scaleName !== ''
      ) {
        // console.log('::: PLANTÕES DO USUÁRIO -> [updated] LOADING "' + this.scaleName + '" SCALE DUTIES...')

        this.startDuties(this.scaleID, this.scaleName, this.currentMonth, this.currentYear)
      }
    },

    beforeDestroy () {
      const { groupID, userID } = this

      this.stopDuties()
      this.clearComponent()

      // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> beforeDestroy:', groupID, userID, this.$store.state.group)
    },

    unmounted () {
      const { groupID, userID } = this.$route.params

      // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> unmounted:', groupID, userID, this.$store.state.group)
    },

    methods: {
      /**
       *
       * MAINTENANCE
       *
       */

      clearComponent () {
        this.groupplaceholder = null
        delete this.groupplaceholder

        this.loadingDuties = true
        delete this.loadingDuties

        this.dutiesRef = null
        delete this.dutiesRef
        this.appointmentsDates = []
        delete this.appointmentsDates

        this.userID = ''
        delete this.userID
        this.groupID = ''
        delete this.groupID

        this.scaleID = ''
        delete this.scaleID
        this.scaleName = ''
        delete this.scaleName
        this.currentYear = ''
        delete this.currentYear
        this.currentMonth = ''
        delete this.currentMonth
        this.currentMonthName = ''
        delete this.currentMonthName

        this.selectMonths = []
        delete this.selectMonths

        // CLEANING
        this.userLocalProfile.userID = null
        this.userLocalProfile.isMe = null
        this.userLocalProfile.userImage = null
        this.userLocalProfile.userImageIsValid = null
        this.userLocalProfile.userName = null
        this.userLocalProfile.userEmail = null
        this.userLocalProfile.userPhone = null
        this.userLocalProfile.userCpf = null
        this.userLocalProfile.userCrm = null
        this.userLocalProfile.userPaymentProfile = null
        this.userLocalProfile = {}
        delete this.userLocalProfile

        this.loadingUserProfile = false
        delete this.loadingUserProfile
      },

      setCurrentYearMonth () {
        const now = moment()
        const currentYear = String(now.format('YYYY')) /* get('year') */
        const currentMonth = String(now.format('MM')) /* get('month') */
        const currentMonthName = this.selectMonths.find(monthItem => monthItem.value === currentMonth).text

        this.currentYear = currentYear
        this.currentMonth = currentMonth
        this.currentMonthName = currentMonthName

        // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> SYSTEM SELECTED ' + currentMonthName + ' DE ' + currentYear + ' PERIOD')
      },

      /**
       *
       * DUTIES
       * - LOAD, PROCESS AND UNLOAD
       *
       */

      startDuties (scaleID, scaleName, month, year)
      {
        if (this.dutiesRef !== null) {
          // [06/02/25] console.log(`::: PLANTÕES DO USUÁRIO -> CAN'T LOAD SHIFTS FROM "${scaleName}": Already initialized`)
          return false
        }

        // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> LOADING SHIFTS FROM "' + scaleName + '"...')

        this.loadingDuties = true
        this.appointmentsDates = []

        const selectedYear = Number(year)
        const selectedMonth = Number(month) - 1
        const firstDate = moment.utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0]).startOf('day')
        const lastDate = moment.utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0]).endOf('month')

        // [06/02/25] console.log('::: START DUTIES -> DATE RANGE:', firstDate.format('YYYY-MM-DD HH:mm:ss'), lastDate.format('YYYY-MM-DD HH:mm:ss'))
        // [06/02/25] console.log('::: START DUTIES -> userID:', this.userID)

        this.dutiesRef = scaleID === 'all' ? (
          apiGetMunicipalityAppointmentsBetweenTwoDatesRef(this.userID, firstDate, lastDate)
        ) : (
          apiGetSpecialtyAppointmentsRef(scaleID, month, year)
        )

        // [06/02/25] console.log('::: dutiesRef:', this.dutiesRef)

        apiRefOpen(this.dutiesRef, this.onAppointmentsUpdate)
      },

      stopDuties () {
        if (this.dutiesRef !== null) {
          apiRefClose(this.dutiesRef, this.onAppointmentsUpdate)

          this.loadingDuties = false /* Senhor Jesus */
          this.appointmentsDates = []

          this.dutiesRef = null

          // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> STOPPED DUTIES.')
        }
      },

      async onAppointmentsUpdate (dutiesResponse)
      {
        const fbDuties = (dutiesResponse && dutiesResponse.val()) ? dutiesResponse.val() : false
        const duties = (fbDuties && typeof fbDuties === 'object') ? fbDuties : false

        const consultationsID = !!duties === true ? Object.keys(duties) : []
        const consultations = !!duties === true ? Object.entries(duties) : []

        // if (this.loadingDuties === true) {
          // this.loadingDuties = false
        // }

        if (consultationsID.length === 0)
        {
          this.appointmentsDates = []
          this.loadingDuties = false

          return false
        }

        //
        //
        //

        const municipalityConsultations = consultations.filter(([consultationID, consultation]) => !!consultation === true && consultation.groupID === this.$route.params.groupID && consultation.ownerID === this.$route.params.userID)

        const appointmentsDates = [...new Set(municipalityConsultations.map(([consultationID, consultation]) => consultation.startDate))].map(date => ({ date, title: date, appointments: [] }))

        //
        //
        //

        const consultationsWithPatients = municipalityConsultations.filter(([consultationID, consultation]) => !!consultation.patientId === true)

        const patients = await Promise.all(
          consultationsWithPatients.map(async ([consultationID, consultation]) => {
            const patientProfile = await this.getPatient(consultation.patientId)

            return {
              patientId: consultation.patientId,
              firstName: patientProfile.firstName || '',
              lastName: patientProfile.lastName || '',
              dateOfBirth: patientProfile.dateOfBirth || '',
              email: patientProfile.email || '',
              cpf: patientProfile.cpf || '',
              group: patientProfile.group || '',
            }
          })
        )

        //
        //
        //

        municipalityConsultations.forEach(([consultationID, consultation]) => {
          //
          // SEARCH FOR PATIENT PROFILE
          //

          const foundPatientIndex = !!consultation.patientId === true ? patients.findIndex(patient => patient.patientId === consultation.patientId) : -1
          // const patientName = foundPatientIndex !== -1 && !!patients[foundPatientIndex] === true && !!patients[foundPatientIndex].firstName === true ? patients[foundPatientIndex].firstName : ''

          const patientName = foundPatientIndex !== -1 && !!patients[foundPatientIndex] === true ? (
            patients[foundPatientIndex].firstName.length > 0 && patients[foundPatientIndex].lastName.length > 0 ? `${patients[foundPatientIndex].firstName} ${patients[foundPatientIndex].lastName}` : (patients[foundPatientIndex].firstName.length > 0 ? patients[foundPatientIndex].firstName : (patients[foundPatientIndex].lastName || ''))
          ) : ''

          // const patientName = !duty.appointmentPatient === true && !!duty.appointmentPatient.firstName === true ? duty.appointmentPatient.firstName : ''
          // const appointmentPatient = foundPatientIndex !== -1 ? { ...patients[foundPatientIndex] } : false

          //
          // SPECIALTY NAME
          //

          const consultationScale = this.listeners.groupScales.find(scale => scale.scaleID === consultation.scaleID)
          const specialtyName = !!consultationScale === true ? String(consultationScale.scaleName).trim() : ''
          const patientRequired = !!consultationScale === true && !!consultationScale.patientRequired === true

          //
          //
          //

          const dutyStartDate = moment.utc(consultation.timestamp)
          const dutyWeekDay = dutyStartDate.day()
          const dutyWeekDayName = dutyWeekDay === 0 ? 'Domingo' : (dutyWeekDay === 1 ? 'Segunda' : (dutyWeekDay === 2 ? 'Terça' : (dutyWeekDay === 3 ? 'Quarta' : (dutyWeekDay === 4 ? 'Quinta' : (dutyWeekDay === 5 ? 'Sexta' : (dutyWeekDay === 6 ? 'Sábado' : 'Desconhecido'))))))

          // const dutyDay = dutyStartDate.format('DD')
          // const dutyDateFilter = dutyStartDate.format('YYYY/MM')

          //
          //
          //

          const dateIndex = appointmentsDates.findIndex(appointmentDate => appointmentDate.date === consultation.startDate)

          if (dateIndex !== -1)
          {
            if (appointmentsDates[dateIndex].appointments.length === 0) {
              appointmentsDates[dateIndex].title = `${appointmentsDates[dateIndex].title} - ${dutyWeekDayName}`
            }

            // dutyDate: consultation.startDate, // data_inicio,
            // dutyTime: consultation.startTime, // hora_inicio,
            // dutyWeekDayName,
            // dutyDay,
            // dutyDateFilter,

            // consultation: { ...consultation },

            appointmentsDates[dateIndex].appointments.push({
              consultationID,
              appointmentTimestamp: consultation.timestamp,
              startDate: consultation.startDate,

              startTime: consultation.startTime,
              duration: consultation.duration + ' min',
              patientName,
              specialtyId: consultation.scaleID || '',
              specialtyName,

              patientRequired,

              appointment: foundPatientIndex !== -1 && !!patients[foundPatientIndex] === true ? { consultationID, ...consultation, patient: { ...patients[foundPatientIndex] } } : consultation,
            })
          }
        })

        //
        //
        //

        // const order = 'ASC'

        // necessário? firebase já retorna com sort?

        // ORDEM CRESCENTE (a - b) - ORDEM DECRESCENTE (b - a)

        /* appointmentsDates.sort((a, b) => {
          // const aDataInicio = a.appointmentTimestamp
          // const bDataInicio = b.appointmentTimestamp

          const ad = moment(`${a.startDate} ${a.startTime}:00`, 'DD/MM/YYYY HH:mm:ss').unix()
          const bd = moment(`${b.startDate} ${b.startTime}:00`, 'DD/MM/YYYY HH:mm:ss').unix()

          return order === 'ASC' ? (ad - bd) : (bd - ad)
        }) */

        // Senhor Jesus
        // [06/02/25] console.log('::: appointmentsDates:', appointmentsDates)

        this.appointmentsDates = appointmentsDates
        this.loadingDuties = false
      },

      /**
       *
       * MAINTENANCE
       *
       */

      async loadUser (userID) {
        this.loadingUserProfile = true

        const perfil = await getUserByUserID(userID)

        if (!!perfil === false) {
          // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> CAN\'T LOAD USER PROFILE:', perfil)
        } else {
          /* NOME */

          const nomeCompleto = !!perfil.nome === true ? String(perfil.nome).trim() : ''

          /* IMAGEM */

          const isValidImage = !!perfil.img === true && typeof perfil.img === 'string' && perfil.img.indexOf('https://firebasestorage.googleapis.com/') !== -1

          /* TELEFONE */

          const ddd = !!perfil.ddd === true ? String(perfil.ddd).trim() : ''
          const phone = !!perfil.tel === true ? String(perfil.tel).trim() : ''
          const telefone = ddd.length === 2 && (phone.length === 8 || phone.length === 9) ? ('(' + ddd + ') ' + (phone.length === 8 ? phone.replace(/(\d{4})(\d{4})/, '$1-$2') : phone.replace(/(\d{5})(\d{4})/, '$1-$2'))) : ''

          /* CPF */

          let cpf = ''

          try {
            cpf = !!perfil.cpf === true ? String(perfil.cpf).replace(/[^0-9]/g, '') : ''
          } catch (userError) {
            cpf = ''
            // console.log(`::: PLANTÕES DO USUÁRIO -> ERRO AO CARREGAR O CPF DO USUÁRIO "${userID}":`, userError)
          }

          const maskedCPF = cpf.length === 11 ? cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})*/, '$1.$2.$3-$4') : ''

          /* ME */

          const currentID = !!this.userSession === true && !!this.userSession.uid === true ? this.userSession.uid : false

          /* USER */

          const userLocalProfile = {
            userID,
            isMe: userID === currentID,
            userImage: isValidImage ? perfil.img : userProfileBroken,
            userImageIsValid: isValidImage,
            userName: nomeCompleto ? nomeCompleto.split(' ')[0] : '',
            userEmail: !!perfil.email === true ? perfil.email.trim() : '',
            userPhone: telefone,
            userCpf: maskedCPF,
            userCrm: !!perfil.crm === true ? perfil.crm.trim() : '',
            userPaymentProfile: !!perfil.conta === true ? perfil.conta.trim() : '',
          }

          this.userLocalProfile = userLocalProfile

          // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> LOADED USER PROFILE:', userLocalProfile)
        }

        this.loadingUserProfile = false
      },

      /**
       *
       * SCALE, MONTH AND YEAR SELECTS EVENTS
       *
       */

      onSelectScale (scaleID, scaleName) {
        // [06/02/25] console.log('::: PLANTÕES DO USUÁRIO -> USER SELECTED "' + scaleName + '" OPTION. (ID: ' + scaleID + ')')

        this.scaleID = scaleID
        this.scaleName = scaleName

        this.stopDuties()
        this.startDuties(scaleID, scaleName, this.currentMonth, this.currentYear)
      },

      selectedMonth (month) {
        // console.log('::: PLANTÕES DO USUÁRIO -> SELECTED MONTH:', month)

        this.currentMonthName = this.selectMonths.find(monthItem => monthItem.value === month).text
        this.currentMonth = month

        this.stopDuties()
        this.startDuties(this.scaleID, this.scaleName, month, this.currentYear)
      },

      selectedYear (year) {
        // console.log('::: PLANTÕES DO USUÁRIO -> SELECTED YEAR:', year)

        this.currentYear = year

        this.stopDuties()
        this.startDuties(this.scaleID, this.scaleName, this.currentMonth, year)
      },

      /**
       *
       * NAVIGATION
       *
       */

      // OPEN "VIEW DUTY" WINDOW/POPUP/MODAL

      openAppointmentEditModal (appointment)
      {
        /* this.$refs.appointmentEditModal.open({
          patientRequired: appointment.patientRequired,
          scaleID: appointment.specialtyId || '',
          scaleName: appointment.specialtyName || '',
          selectedDate: appointment.startDate,
          consultation: { ...appointment.appointment, consultationID: appointment.consultationID },
          consultationDuration: appointment.duration,
        }) */

        const appointmentDetails = {
          patientRequired: appointment.patientRequired,

          id: appointment?.consultationID,

          regulationCode: String(appointment?.regulation_code ?? ''),
          confirmationKey: String(appointment?.confirmation_key ?? ''),

          attendanceStatus: String(appointment?.patientAttendance || ''),
          reminderId: String(appointment?.reminder?.id ?? ''),

          scaleID: appointment.specialtyId || '',
          scaleName: appointment.specialtyName || '',

          municipalityID: appointment?.ownerID,

          observation: appointment?.obs || '',

          timestamp: appointment?.timestamp,
          date: appointment.startDate,
          startTime: appointment?.startTime,
          endTime: appointment?.endTime,
          duration: appointment.duration,

          patientID: String(appointment?.patientId || ''),
          patientFirstName: String(appointment?.patient?.firstName ?? '').trim(),
          patientLastName: String(appointment?.patient?.lastName ?? '').trim(),
          patientDateOfBirth: String(appointment?.patient?.dateOfBirth ?? ''),
          patientEmail: String(appointment?.patient?.email ?? ''),
          patientCpf: String(appointment?.patient?.cpf ?? ''),
          patientUnitName: String(appointment?.patient?.group ?? ''),

          doctorID: String(appointment?.doctor?.id ?? ''),
          doctorName: String(appointment?.doctor?.name ?? ''),

          locationType: appointment?.typeOfMedicalCare || '0',
          locationID: String(appointment?.reminder?.group_id ?? ''),
          locationName: String(appointment?.reminder?.unitName ?? ''),
          locationAddress: String(appointment?.reminder?.unitAddress ?? ''),
        }

        this.$refs.appointmentEditModal.open(appointmentDetails)
      },

      async getPatient (patientId)
      {
        var patient = patientId && this.groupPatients && this.groupPatients.length > 0 ? this.groupPatients.find(patient => patient.patientId === patientId) : false
        if (!!patient === true) return patient

        const patientProfile = await getPatientByID(patientId)

        if (!!patientProfile === true) {
          this.groupPatients.push(patientProfile)
        }

        return !!patientProfile === false ? false : patientProfile
      },

      // BACK TO THE "GROUP DETAILS" SCREEN
      goBackToGroupScales () {
        this.$router.push(`/admin/grupos/${this.$route.params.groupID}/escalas`)
      },

      // GO TO THE "SUBSCRIPTION" SCREEN
      navigateToPlans () {
        this.$router.push('/admin/assinatura')
      },
    },
  }

</script>

<style lang="sass" scoped>
  .sosField
    z-index: 2
    position: relative

    margin-top: 15px
    margin-bottom: 15px

    &.sosField--first
      margin-top: 0

    &.sosField--last
      margin-bottom: 0

  .sosFieldGroup
    z-index: 1
    position: relative

    // margin-top: 15px
    // margin-bottom: 15px
    margin-top: 10px
    margin-bottom: 10px
    margin-left: -5px
    margin-right: -5px

    .sosField
      display: inline-block
      vertical-align: middle
      padding: 5px
      margin-top: 0
      margin-bottom: 0

      &.sosFieldColumn--1,
      &.sosFieldColumn--2
        width: 50%

  //

  .loaderGestor
    display: block
    height: 20px
    width: 20px
    -webkit-animation: loaderGestor 800ms linear infinite
    animation: loaderGestor 800ms linear infinite

  @-webkit-keyframes loaderGestor
    0%
      -webkit-transform: rotate(0deg)
    100%
      -webkit-transform: rotate(360deg)

  @keyframes loaderGestor
    0%
      transform: rotate(0deg)
    100%
      transform: rotate(360deg)

  .loaderGestor span
    display: block
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    margin: auto
    height: 20px
    width: 20px
    clip: rect(10px, 20px, 20px, 0)
    -webkit-animation: loaderGestor-2 400ms cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite
    animation: loaderGestor-2 400ms cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite

  @-webkit-keyframes loaderGestor-2
    0%
      -webkit-transform: rotate(0deg)
    100%
      -webkit-transform: rotate(360deg)

  @keyframes loaderGestor-2
    0%
      transform: rotate(0deg)
    100%
      transform: rotate(360deg)

  .loaderGestor span::before
    content: ""
    display: block
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    margin: auto
    height: 20px
    width: 20px
    border: 1px solid transparent
    border-top: 1px solid #000000
    border-radius: 50%
    -webkit-animation: loaderGestor-3 400ms cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite
    animation: loaderGestor-3 400ms cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite

  @-webkit-keyframes loaderGestor-3
    0%
      -webkit-transform: rotate(0deg)
    100%
      -webkit-transform: rotate(360deg)

  @keyframes loaderGestor-3
    0%
      transform: rotate(0deg)
    100%
      transform: rotate(360deg)

  .loaderGestor span::after
    content: ""
    display: block
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    margin: auto
    height: 20px
    width: 20px
    border: 1px solid rgba(0, 0, 0, 0.5)
    border-radius: 50%

  .btn
    position: relative

  @media (max-width: 1280px)
    .groupUserDuties
      overflow-x: auto

  @media (max-width: 768px)
    .groupUserDuties
      overflow-x: visible

</style>

<style scoped lang="scss">
  .pageBody {
    margin-top: 20px;
    // padding: 20px 30px;
    padding: 30px;
    border-radius: 5px;
    // border-top-left-radius: 5px;
    // border-top-right-radius: 5px;
    background-color: white;
    box-shadow: 0px 3px 7px -5px rgba(0, 0, 0, 0.5);
  }

  .pageGroupContainer {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  .userProfileItem {
    font-size: 15px;
    line-height: 30px;
  }

  .groupTitleImage,
  .groupTitleText {
    display: inline-block;
    vertical-align: top;
  }

  .groupTitleImage {
    width: 25%;
    height: 80px;
    max-width: 80px;

    .groupImage {
      display: inline-block;
      width: 80px;
      height: 80px;
      overflow: hidden;
      border-radius: 7px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.1);

      .groupUserImage {
        display: inline-block;
        width: 100%;
        max-width: 80px;
        height: 80px;
        background-repeat: no-repeat;
        background-size: cover;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }

  .groupTitleText {
    width: 75%;
    padding-left: 20px;
  }

  .groupUserDutiesHeader {
    margin-top: 30px;
    padding: 10px 30px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: dodgerblue;

    color: #FFFFFF;
    font-size: 18px;
    font-weight: 600;
  }

  /* .groupUserDuties--loadingWrapper {
    transition-property: opacity, visibility;
    transition-duration: 200ms;

    opacity: 0;
    visibility: hidden;

    z-index: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background-color: rgba(0, 0, 0, 0.5);

    span {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      display: inline-block;
      height: 25px;
      margin: auto;

      color: #FFFFFF;
      font-weight: 500;
      text-align: center;
      line-height: 25px;
    }
  } */

  .groupUserDutiesMonthWrapper {
    transition-property: opacity;
    transition-duration: 200ms;
  }

  .monthDay {
    padding-left: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    // border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: rgba(0, 0, 0, 0.1);

    font-weight: 600;
    line-height: 1.5;
  }

  .monthDayBody {
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    // border-right: 1px solid rgba(0, 0, 0, 0.1);
    // border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    table {
      width: 100%;

      td {
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 5px;
        padding-bottom: 5px;

        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        border-right: 1px solid rgba(0, 0, 0, 0.1);
      }
    }
  }

  .groupUserDuties {
    position: relative;
    padding: 27px;
    // padding: 30px; // retirar
    border-left: 1px solid rgba(30, 144, 255, 0.5);
    border-right: 1px solid rgba(30, 144, 255, 0.5);
    border-bottom: 1px solid rgba(30, 144, 255, 0.5);
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;

    &.groupUserDuties--loading {
      /* .groupUserDuties--loadingWrapper {
        opacity: 1;
        visibility: visible;
      } */

      .groupUserDutiesMonthWrapper {
        opacity: 0.2;
      }
    }
  }

  /* .groupUserDutiesColumn--1,
  .groupUserDutiesColumn--2 {
    display: inline-block;
    vertical-align: middle;
    padding: 30px;
  }

  .groupUserDutiesColumn--1 {
    width: 25%;
    border-right: 1px solid rgba(30, 144, 255, 0.5);
  }

  .groupUserDutiesColumn--2 {
    width: 75%;
  } */

  /* .groupUserDutiesMonth--duties {
    margin: -3px;
  } */

  .groupUserDutiesMonth--duty {
    user-select: none;

    position: relative;

    display: inline-block;
    vertical-align: middle;
    width: 105px;
    height: 85px;
    margin: 3px;
    border-radius: 10px;
    box-shadow: inset -1px -1px 1px rgba(0, 0, 0, 0.18);
    background-color: orange;
    // background-color: darkseagreen;

    // overflow: hidden; // Nota: NECESSÁRIO?

    color: #FFF;
    text-align: center;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);

    &.groupUserDutiesMonth--duty__started {
      // greenyellow lightseagreen
      background-color: greenyellow;
      color: #555555;
      text-shadow: none;

      .groupUserDutiesMonth--dutyWeekDay {
        font-weight: 500;
      }

      .groupUserDutiesMonth--dutyDay {
        font-weight: 400;
      }

      .groupUserDutiesMonth--dutyTime {
        font-weight: 500;
      }

      .groupUserDutiesMonth--dutyValue {
        font-weight: 500;
      }
    }

    &.groupUserDutiesMonth--duty__cancelled {
      background-color: orangered;
      color: #DDDDDD;
    }

    &.groupUserDutiesMonth--duty__finished {
      // background-color: teal;
      background-color: #502c2c;
      color: #DDDDDD;
      /* background-color: steelblue;
      color: #EEEEEE; */
    }

    .groupUserDutiesMonth--dutyBody {
      position: relative;
      padding: 8px 10px 0 10px;

      .dutyLabel {
        position: absolute;
        transform: rotate(-7deg);
        left: -7px;
        top: 52px;

        width: 120px;
        background-color: rgba(255, 255, 0, 0.8);

        color: #000000;
        font-size: 9px;
        line-height: 12px;
        font-weight: 500;
        letter-spacing: 1px;
        text-transform: uppercase;
      }
    }

    .groupUserDutiesMonth--dutyValue {
      margin-top: 5px;
      padding: 3px;
      border-radius: 0;
      overflow: hidden; // ...
      background-color: rgba(0, 0, 0, 0.1);

      font-size: 11px;
      line-height: 11px;
      font-weight: 600;

      text-overflow: ellipsis; // ...
    }
  }

  .dutyCard--passing {
    position: absolute;
    top: -5px;

    height: 15px;
    padding: 0px 5px;
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background-color: rgba(0, 100, 0, 0.8);

    font-size: 9px;
    line-height: 15px;
    font-weight: 600;
    text-shadow: none;
  }

  .groupUserDutiesMonth--dutyInner1 {
    display: inline-block;
    vertical-align: middle;
    width: 40%;
    text-align: center;
  }

  .groupUserDutiesMonth--dutyInner2 {
    display: inline-block;
    vertical-align: middle;
    width: 60%;
    padding-left: 7px;
    text-align: right;
  }

  .groupUserDutiesMonth--dutyWeekDay {
    margin-bottom: 3px;
    font-size: 12px;
    line-height: 12px;
    font-weight: 800;
    /* text-transform: uppercase; */
  }

  .groupUserDutiesMonth--dutyDay {
    font-size: 24px;
    line-height: 24px;
    font-weight: 500;
  }

  .groupUserDutiesMonth--dutyTime {
    margin-top: 3px;
    font-size: 11px;
    line-height: 12px;
    font-weight: 800;
    text-align: left;

    span {
      display: inline-block;
      width: 100%;
    }
  }

  //

  p {
    margin: 0;
  }

  .info-card-item-upgrade-container {
    padding: 0 0 !important;
    display: flex;
    flex-direction: row;
    min-height: 80px;
    height: 100% !important;
    text-transform: none;
  }

  .btn-info-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .plan-description {
    color: #000;
    font-weight: 400;
  }

  .plan-name {
    font-size: 19px;
    color: #000;
  }

  .upgrade-text {
    color: #FFF;
  }

  .upgrade-arrow-icon {
    width: 50px;
    height: 50px;
  }

  ul {
    list-style: none;
  }

  /*  */

  .column {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    @media (min-width: 767px) {
      justify-content: center;
    }
    &[start] {
      justify-content: flex-start;
    }
    &[end] {
      justify-content: flex-end;
    }
    &[space-between] {
      justify-content: space-between;
    }
  }

  .blockTitle {
    color: #305050;
    font-size: 25px;
    line-height: 25px;
  }

  .csCol {
    display: inline-block;
    vertical-align: top;

    &.csCol--1 {
      width: 50%;
      // width: 40%;
    }

    &.csCol--2 {
      width: 50%;
      // width: 40%;
    }

    // &.csCol--3 {
      // width: 20%;
    // }
  }

  // .csCol--3 {
    // text-align: right;
  // }

  @media (max-width: 1280px) {
    .csCol {
      &.csCol--1 {
        width: 50%;
      }

      &.csCol--2 {
        width: 50%;
      }

      // &.csCol--3 {
        // width: 100%;
        // margin-top: 25px;

        // text-align: center;
      // }
    }
  }

  @media (max-width: 1164px) {
    .groupTitleImage {
      width: 30%;
    }

    .groupTitleText {
      width: 70%;
    }
  }

  @media (max-width: 960px) {
    .groupTitleArea {
      position: relative;
    }

    .groupTitleImage {
      position: absolute;
      left: 0;
      top: 0;

      width: 100%;
    }

    .groupTitleText {
      width: 100%;
      padding-left: 100px;
    }

    .csCol {
      &.csCol--1 {
        width: 100%;
      }

      &.csCol--2 {
        width: 100%;
        margin-top: 35px;
      }

      // &.csCol--3 {
        // width: 100%;
      // }
    }
  }

  @media (max-width: 600px) {
    .btnVoltar {
      width: 100%;
    }
  }
</style>
